import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { settings, ClientSettingsProvider, ClientSettingsConsumer } from './context/ClientSettingsContext';
import './index.css';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';

import store from './redux/store';
import GlobalConfig from './utils/GlobalConfig';
const queryString = require('query-string');


fetch('./envconfig.json')
  .then(response => response.json())
  .then((data) => {
    GlobalConfig.setConfig(data);

    const query = queryString.parse(window.location.search.toLowerCase());
    const floorIndex = Number(query.floorindex);
    const configuration = query.configuration;
    if (configuration) {
        GlobalConfig.setClientNameOverride(configuration);
    }


    ReactDOM.render(
      <Provider store={store}>
        <ClientSettingsProvider value={settings[GlobalConfig.get(GlobalConfig.Key.CLIENT_NAME)]}>
          <ClientSettingsConsumer>
            {({
              defaultCommunityRID,
              defaultModelRID,
              showInitialLoadingProgress,
              touchscreenEnabled,
              useKovaPDFDownloader,
              showKovaStage,
              loadModelRules,
              colorSelectorEnabled,
              communityDropdownList,
              showCommunityDropdownList,
              clientFloorOnAppLoad
            }) => (
              <App
                defaultCommunityRID={defaultCommunityRID}
                defaultModelRID={defaultModelRID}
                showInitialLoadingProgress={showInitialLoadingProgress}
                touchscreenEnabled={touchscreenEnabled}
                useKovaPDFDownloader={useKovaPDFDownloader}
                showKovaStage={showKovaStage}
                loadModelRules={loadModelRules}
                colorSelectorEnabled={colorSelectorEnabled}
                communityDropdownList={communityDropdownList}
                showCommunityDropdownList={showCommunityDropdownList}
                clientFloorOnAppLoad={floorIndex ? floorIndex : clientFloorOnAppLoad}
              />
            )}
          </ClientSettingsConsumer>
        </ClientSettingsProvider>
      </Provider>,
      document.getElementById('root')
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
  });
